import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Content to display inside the badge (e.g., reward amount) */
  children: PropTypes.node,
  /** If true, hides the badge from assistive technologies (aria-hidden) */
  isDecorative: PropTypes.bool,
  /** Visual state of the badge, used for different reward or gift types */
  state: PropTypes.oneOf(['', 'bounce-back-rewards', 'tier1-gift']),
  /** Badge theme for color contrast */
  theme: PropTypes.oneOf(['', 'inverse'])
};
function GraphicBadge(_ref) {
  var isDecorative = _ref.isDecorative,
    children = _ref.children,
    state = _ref.state,
    theme = _ref.theme;
  return /*#__PURE__*/React__default.createElement("div", {
    "aria-hidden": isDecorative,
    className: "graphic-badge",
    "data-state": state,
    "data-testid": "graphic-badge",
    "data-theme": theme
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "graphic-badge-inner",
    "data-testid": "graphic-badge-inner"
  }, children && /*#__PURE__*/React__default.createElement("span", {
    className: "graphic-badge-value",
    "data-testid": "graphic-badge-value"
  }, children)));
}
GraphicBadge.propTypes = propTypes;

export { GraphicBadge as default };
//# sourceMappingURL=GraphicBadge.js.map
